import { ModerationError, ModerationFieldType } from '../models/Moderation';
import { ModerationRepository } from '../repositories/ModerationRepository';

export class ModerateContentUseCase {
  constructor(private moderationRepo: ModerationRepository) {}

  async execute(text: string, fieldType: ModerationFieldType, userId: string): Promise<void> {
    const decision = await this.moderationRepo.moderate({ text, fieldType, userId });
    if (decision.action === 'block') {
      throw new ModerationError(decision.reasons);
    }
  }

  async executeImage(imageUrl: string, fieldType: ModerationFieldType, userId: string): Promise<void> {
    const decision = await this.moderationRepo.moderate({ imageUrl, fieldType, userId });
    if (decision.action === 'block') {
      throw new ModerationError(decision.reasons);
    }
  }
}
